<template>
  <div style="text-align: center">
    <div class="p-grid">
      <div class="p-col-12 p-mt-5">
        <h1>Zugriff verweigert</h1>
      </div>
      <div class="p-col-12 p-mt-5">
        Sie haben keine Berechtigungen für diese Seite bitte wenden Sie
        sich an eine(n) Verantwortliche(n).
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "AccessDeniedPage",
  methods: {}
}
</script>

<style scoped>

</style>